// Dropdown da conta no avatar do header desktop.
// Abre/fecha pelo botão; fecha com Esc, clique fora ou ao sair da página.
// Ao abrir dispara `cda:account-menu-open` (o tooltip de livros em construção fecha).

var documentHandlers = [];

function addDocumentHandler(type, handler) {
  document.addEventListener(type, handler);
  documentHandlers.push(function() { document.removeEventListener(type, handler); });
}

function setupAccountMenu(toggle) {
  var menu = document.getElementById(toggle.getAttribute('aria-controls'));
  if (!menu) return;

  function setOpen(open, restoreFocus) {
    menu.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) document.dispatchEvent(new CustomEvent('cda:account-menu-open'));
    if (!open && restoreFocus) toggle.focus();
  }

  setOpen(false);

  toggle.addEventListener('click', function() {
    setOpen(menu.hidden);
  });

  addDocumentHandler('mousedown', function(event) {
    if (!menu.hidden && !menu.contains(event.target) && !toggle.contains(event.target)) setOpen(false);
  });

  addDocumentHandler('keydown', function(event) {
    if (!menu.hidden && (event.key === 'Escape' || event.key === 'Esc')) setOpen(false, true);
  });

  addDocumentHandler('turbolinks:before-cache', function() { setOpen(false); });
}

document.addEventListener('turbolinks:load', function() {
  documentHandlers.forEach(function(remove) { remove(); });
  documentHandlers = [];

  Array.prototype.forEach.call(document.querySelectorAll('[data-cda-account-toggle]'), setupAccountMenu);
});
